class SimpleTextFieldModel {
  constructor(value = "") {
    this.value = value; // Initialize with a string (the actual value)
  }

  // Getter for the value
  getValue() {
    return this.value;
  }

  // Setter for the value
  setValue(newValue) {
    this.value = newValue;
  }

  // Optional: A method to serialize the model data for form submissions
  toJSON() {
    return this.value; // No longer returning an object, just the string value
  }
}

export default SimpleTextFieldModel;
